<template>
  <div class="container">

    <div class="text-center">
      <h2>Die Trauerfeier</h2>
      <img src="../../assets/promize-icone.png" alt="">
    </div>


    <VuePureLightbox
        :images="images"
        :open-at-index="index"
        ref="lightbox"
    >
      <template v-slot:content="{ url: { link, alt, text, headline } }">
        <div class="lightbox-holder container">
          <img :src="link" :alt="alt" v-if="link">
          <div class="text-holder bg-white py-3 px-6 pt-1" v-else>
            <h2>{{ headline }}</h2>
            <p v-html="text"></p>
          </div>
        </div>
      </template>
    </VuePureLightbox>

    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 mt-3">
      <a href="/img/MG_4621-scaled.jpg" target="_blank" v-on:click.prevent="show(0)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4621-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4613R-scaled.jpg" target="_blank" v-on:click.prevent="show(1)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4613R-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4570-scaled.jpg" target="_blank" v-on:click.prevent="show(2)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4570-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4622-scaled.jpg" target="_blank" v-on:click.prevent="show(3)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4622-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4644-scaled.jpg" target="_blank" v-on:click.prevent="show(4)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4644-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4630-scaled.jpg" target="_blank" v-on:click.prevent="show(5)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4630-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4687R-scaled.jpg" target="_blank" v-on:click.prevent="show(6)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4687R-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4695R-scaled.jpg" target="_blank" v-on:click.prevent="show(7)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4695R-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4723b-scaled.jpg" target="_blank" v-on:click.prevent="show(8)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4723b-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4720R-scaled.jpg" target="_blank" v-on:click.prevent="show(9)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4720R-scaled.jpg" alt="">
      </a>
      <a href="/img/MG_4723-scaled.jpg" target="_blank" v-on:click.prevent="show(10)" class="col square">
        <img class="img-fluid" src="../../assets/MG_4723-scaled.jpg" alt="">
      </a>


      <a href="#" v-on:click.prevent="show(11)" class="col square d-flex justify-content-center align-items-center">
        <img class="img-fluid border" alt=""
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=">
        <h3>Ein Lebens&shy;abschnitt</h3>
      </a>
      <a href="#" v-on:click.prevent="show(12)" class="col square d-flex justify-content-center align-items-center">
        <img class="img-fluid border" alt=""
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=">
        <h3>Lieder</h3>
      </a>
      <a href="#" v-on:click.prevent="show(13)" class="col square d-flex justify-content-center align-items-center">
        <img class="img-fluid border" alt=""
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=">
        <h3>Ablauf</h3>
      </a>
      <a href="#" v-on:click.prevent="show(14)" class="col square d-flex justify-content-center align-items-center">
        <img class="img-fluid border" alt=""
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=">
        <h3>Predigt</h3>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePureLightbox from 'vue-pure-lightbox'

export default {
  name: 'gallery',
  components: { VuePureLightbox },
  data () {
    return {
      images: [
        { link: '/img/MG_4621-scaled.jpg', asset: '../../MG_4621-scaled.jpg' },
        { link: '/img/MG_4613R-scaled.jpg', asset: '../../MG_4613R-scaled.jpg' },
        { link: '/img/MG_4570-scaled.jpg', asset: '../../MG_4570-scaled.jpg' },
        { link: '/img/MG_4622-scaled.jpg', asset: '../../MG_4622-scaled.jpg' },
        { link: '/img/MG_4644-scaled.jpg', asset: '../../MG_4644-scaled.jpg' },
        { link: '/img/MG_4630-scaled.jpg', asset: '../../MG_4630-scaled.jpg' },
        { link: '/img/MG_4687R-scaled.jpg', asset: '../../MG_4687R-scaled.jpg' },
        { link: '/img/MG_4695R-scaled.jpg', asset: '../../MG_4695R-scaled.jpg' },
        { link: '/img/MG_4723b-scaled.jpg', asset: '../../MG_4723b-scaled.jpg' },
        { link: '/img/MG_4720R-scaled.jpg', asset: '../../MG_4720R-scaled.jpg' },
        { link: '/img/MG_4723-scaled.jpg', asset: '../../MG_4723-scaled.jpg' },

        {
          headline: 'Ein Lebensabschnitt',
          text: 'Ich (Peter) möchte einen Vers aus der Bibel allem voranstellen. Er war zentral für unser Leben als Ehepaar. Insbesondere in der letzten Zeit die wir gemeinsam hatten. „Das eine aber wissen wir: Wer Gott liebt, dem dient alles, was geschieht, zum Guten. Dies gilt für alle, die Gott nach seinem Plan und Willen zum neuen Leben erwählt hat.“ (Römer 8,28, HfA) Am 18. Oktober feierten wir ihren Geburtstag auf der Intensivstation in Detmold. Da wurde sie 36 Jahre alt. Wir versuchten es uns so schön wie möglich zu machen. Es war nicht das erste Mal. Wir hatten das schon mal vor 4 Jahren. Da haben wir auch Weihnachten im Krankenhaus gefeiert. In all dieser Zeit hat Angelika das Lachen nicht verlernt. Sie konnte noch Sprüche klopfen und die anderen in ihren Nöten sehen. Wir glückliche und auch dunkle Stunden in denen wir miteinander den Schmerz von der Seele geweint haben. Wir durften daran festhalten, dass Gottes Versprechen zählt. Das alles was uns Kinder Gottes geschieht, zum Besten dient. Auch wenn man sich fragt: Was soll daran gut sein? Dieser Vers vom Anfang hat uns in den letzten 4,5 Jahren hindurchgetragen. Angelika wurde am 18.Oktober 1983, als erstes Kind von Heinrich und Katharina Römmich, in Bielefeld geboren. Vier Jahre später folgte ihr Bruder Dennis. Gemeinsam lebten sie in Stukenbrock und Schlangen. In Schlangen besuchte sie die Schule. Dann ging es nach Oesterholz. Da lernte ich sie in der Jugendgruppe kennen. Ich war damals zurückgezogen und schüchtern. Sie ermutigte mich und forderte mich heraus, meine Ecke zu verlassen und mich rauszuwagen. Da waren wir aber noch nicht zusammen. Als wir mit 17 Jahren eine Beziehung starteten, war es aufgrund meiner Unreife nicht so einfach. Nach knapp zwei Jahren beendete sie die Beziehung. Weitere zwei Jahre hatte ich Zeit bekommen darüber nachzudenken, ob es der Weg ist den Gott für mich bereithält. In dieser Reifungszeit habe ich auf Gottes Antwort gewartet. Und sie kam. Rückblickend betrachtet, hatte Gott alles gut geführt. Wir starteten erneut in die Beziehung und ich durfte meine Traumfrau, weitere zwei Jahre später heiraten und das Leben nun mit ihr teilen. Ich bin von Herzen Gott dankbar für jeden einzelnen Tag den wir gemeinsam hatten. Manchmal waren wir auf Wolke sieben, und manchmal waren die Nerven blank. Unser Start war nicht einfach und das Ende der Ehe auch nicht, aber heute darf ich mit größter Gewissheit sagen: Angelika hat mich und die Kinder immer sehr geliebt. Sie schrieb in den letzten Jahren eine Art Tagebuch für uns. Für den Fall, dass sie nicht mehr dasein sollte, haben wir immer was zu lesen wenn wir es wollen. Als ich das erste Buch vor etwa 2 Jahren las, wurde mir klar, dass ihre Liebe zu uns viel tiefer war als ich es annahm. Es öffnete mir die Augen, sodass ich zu lernen anfing ihre Sprache zu verstehen mit der sie ihre Liebe zu uns ausdrückte. Es war spät, aber ich konnte noch zwei Jahre ihre Sprache vernehmen und sie ein Stückweit lernen. Sie wollte noch gerne bei uns sein und für Noah (8) und Sophia (4) sorgen. Sie aufwachsen sehen, zum Beispiel wie Noah die Bibelschule absolviert so wie sie es auch mal tat. Oder sehen wie ich Sophia zum Traualtar führe. Aber sie freute sich auch auf den Himmel. Wo sie bei Jesus sein kann, der sie geliebt und errettet hat. Und es unvorstellbar schön sein wird. Mit dieser Hoffnung und der Freude starb sie am Mittwoch den 20.11.2019 um halb fünf morgens. Ich durfte die ganze Zeit bei ihr bleiben und sie bis zu ihrem letzten Atemzug begleiten. Nun ist sie beim Herrn, wo wir auch sein werden. Wir sehen uns wieder, Angelika. Danke für jede Sekunde deines Lebens das du mit mir geteilt hast. Bis bald. Dein Peter mit Noah und Sophia.',
        },
        {
          headline: 'Lieder',
          text: '<h3>Von guten Mächten</h3>\n' +
              '<p>Von guten Mächten treu und still umgeben,<br/>\n' +
              'behütet und getröstet wunderbar,<br/>\n' +
              'so will ich diese Tage mit euch leben<br/>\n' +
              'und mit euch gehen in ein neues Jahr.</p>\n' +
              '\n' +
              '<p>Noch will das alte unsre Herzen quälen,<br/>\n' +
              'noch drückt uns böser Tage schwere Last.<br/>\n' +
              'Ach Herr, gib unsern aufgeschreckten Seelen<br/>\n' +
              'das Heil, für das du uns geschaffen hast.</p>\n' +
              '\n' +
              '<p>Und reichst du uns den schweren Kelch, den bittern<br/>\n' +
              'des Leids, gefüllt bis an den höchsten Rand,<br/>\n' +
              'so nehmen wir ihn dankbar ohne Zittern<br/>\n' +
              'aus deiner guten und geliebten Hand.</p>\n' +
              '\n' +
              '<hr>\n' +
              '\n' +
              '<p>Wenn sich die Stille nun tief um uns breitet,<br/>\n' +
              'so lass uns hören jenen vollen Klang der Welt,<br/>\n' +
              'die unsichtbar sich um uns weitet,<br/>\n' +
              'all deiner Kinder hohen Lobgesang.</p>\n' +
              '\n' +
              '<p>Ref.: Von guten Mächten wunderbar geborgen,<br/>\n' +
              'erwarten wir getrost, was kommen mag.<br/>\n' +
              'Gott ist bei uns am Abend und am Morgen<br/>\n' +
              'und ganz gewiss an jedem neuen Tag.</p>\n' +
              '\n' +
              '<hr>\n' +
              '\n' +
              '<h3>Da kann man nur staunen über Gott</h3>\n' +
              '\n' +
              '<p>Wie viel schöne Stunden hat mir Gott bis jetzt geschenkt,<br/>\n' +
              'wie viel gute Jahre, wie viel Liebe.<br/>\n' +
              'Wie viel Hilfe konnte ich in kleinen Dingen sehn,<br/>\n' +
              'wüsste nicht, wo ich alleine bliebe.<br/>\n' +
              'Da kann man nur staunen über Gott<br/>\n' +
              'und über die Wunder, die er tut,<br/>\n' +
              'einfach nur staunen.</p>\n' +
              '\n' +
              '<p>Wie viel Engel wurden wohl für mich schon losgeschickt,<br/>\n' +
              'wie viel Druck hat Gott von mir genommen.<br/>\n' +
              'Wie viel Trost fand ich bei ihm in Zeiten schwerer Not.<br/>\n' +
              'Wie viel Zuspruch habe ich bekommen.<br/>\n' +
              'Da kann man nur staunen über Gott<br/>\n' +
              'und über die Wunder, die er tut,<br/>\n' +
              'einfach nur staunen.</p>\n' +
              '\n' +
              '<p>Wie oft habe ich gezweifelt, wie oft hinterfragt,<br/>\n' +
              'wie oft fast den Glauben aufgegeben.<br/>\n' +
              'Wie oft wurde ich beschämt und wie oft überrascht.<br/>\n' +
              'Gott ist gut und ihm gehört mein Leben.<br/>\n' +
              'Da kann man nur staunen über Gott<br/>\n' +
              'und über die Wunder, die er tut,<br/>\n' +
              'einfach nur staunen.</p>\n' +
              '\n' +
              '\n' +
              '\n' +
              '<h3>In Christus</h3>\n' +
              '\n' +
              '<p>In Christus ist mein ganzer Halt.<br/>\n' +
              'Er ist mein Licht, mein Heil, mein Lied,<br/>\n' +
              'der Eckstein und der feste Grund,<br/>\n' +
              'sicherer Halt in Sturm und Wind.<br/>\n' +
              'Wer liebt wie er, stillt meine Angst,<br/>\n' +
              'bringt Frieden mir mitten im Kampf?<br/>\n' +
              'Mein Trost ist er in allem Leid.</p>\n' +
              '\n' +
              '<p>In seiner Liebe find ich Halt.<br/>\n' +
              'Das ew`ge Wort, als Mensch gebor`n.<br/>\n' +
              'Gott offenbart in einem Kind.<br/>\n' +
              'Der Herr der Welt, verlacht, verhöhnt<br/>\n' +
              'und von den Seinen abgelehnt.<br/>\n' +
              'Doch dort am Kreuz, wo Jesus starb<br/>\n' +
              'und Gottes Zorn ein Ende fand,<br/>\n' +
              'trug er die Schuld der ganzen Welt.<br/>\n' +
              'Durch seine Wunden bin ich heil.</p>\n' +
              '\n' +
              '<p>Sie legten ihn ins kühle Grab.<br/>\n' +
              'Dunkel umfing das Licht der Welt.<br/>\n' +
              'Doch morgens früh am dritten Tag<br/>\n' +
              'wurde die Nacht vom Licht erhellt.<br/>\n' +
              'Der Tod besiegt, das Grab ist leer,<br/>\n' +
              'der Fluch der Sünde ist nicht mehr,<br/>\n' +
              'denn ich bin sein, und er ist mein.<br/>\n' +
              'Mit seinem Blut macht er mich rein.</p>\n' +
              '\n' +
              '<p>Nun hat der Tod die Macht verlor`n.<br/>\n' +
              'Ich bin durch Christus neu gebor`n.<br/>\n' +
              'Mein Leben liegt in seiner Hand<br/>\n' +
              'vom ersten Atemzuge an.<br/>\n' +
              'Und keine Macht in dieser Welt<br/>\n' +
              'kann mich ihm rauben, der mich hält,<br/>\n' +
              'bis an das Ende dieser Zeit,<br/>\n' +
              'wenn er erscheint in Herrlichkeit.</p>\n' +
              '\n' +
              '<hr>\n' +
              '\n' +
              '<h3>Komm zu Jesus</h3>\n' +
              '\n' +
              '<p>Verwundet, schwach, ein Sünder, verloren, wenn du stirbst.<br/>\n' +
              'O, heb den Kopf, weil Liebe um dich wirbt.</p>\n' +
              '\n' +
              '<p>Komm zu Jesus, komm zu Jesus,<br/>\n' +
              'komm zu Jesus und leb.</p>\n' +
              '\n' +
              '<p>Jetzt ist die Last verschwunden, ins tiefste Meer versenkt.<br/>\n' +
              'Sein Tod hat dir das Leben neu geschenkt.</p>\n' +
              '\n' +
              '<p>Nun sing zu Jesus, sing zu Jesus,<br/>\n' +
              'sing zu Jesus und leb.</p>\n' +
              '\n' +
              '<p>Hab keine Angst zu krabbeln, als neugebornes Kind.<br/>\n' +
              'Vergiss nicht, manchmal fallen wir auch hin.</p>\n' +
              '\n' +
              '<p>Dann fall auf Jesus, fall auf Jesus,<br/>\n' +
              'fall auf Jesus und leb.</p>\n' +
              '\n' +
              '<p>Dein Weg ist manchmal einsam, gepflastert auch mit Schmerz.<br/>\n' +
              'Dein Himmel schwarz und tränenvoll dein Herz</p>\n' +
              '\n' +
              '<p>Dann schrei zu Jesus, schrei zu Jesus,<br/>\n' +
              'schrei zu Jesus und leb.</p>\n' +
              '\n' +
              '<p>Wenn Liebe übersprudelt, Musik die Nacht erfüllt,<br/>\n' +
              'die Freude deine Leidenschaft enthüllt.</p>\n' +
              '\n' +
              '<p>Dann tanz für Jesus, tanz für Jesus,<br/>\n' +
              'tanz für Jesus und leb.</p>\n' +
              '\n' +
              '<p>Und mit dem letzten Herzschlag, sage Lebewohl.<br/>\n' +
              '<p>Geh in Frieden, denn er wartet schon.</p>\n' +
              '\n' +
              '<p>Flieg heim zu Jesus, heim zu Jesus,<br/>\n' +
              'Flieg heim zu Jesus und leb!</p>\n' +
              '\n' +
              '<hr>\n' +
              '\n' +
              '<h3>Im Himmel gibt es manches, was ich gerne möchte sehn</h3>\n' +
              '\n' +
              '<p>1.\tIm Himmel gibt es manches, was ich gern möchte sehn.<br/>\n' +
              'An Schönheit wird mein Herz sich dann erfreun.<br/>\n' +
              'Und wenn ich einst in Ewigkeit zum Himmel werd eingehn:<br/>\n' +
              'Der Erste, den ich seh, soll Jesus sein.</p>\n' +
              '\n' +
              '<p>Der Erste, den ich seh, soll Jesus sein,<br/>\n' +
              'und dann wird alles andre mich erfreun.<br/>\n' +
              'Anbetend werd ich stehn vor dem, der alles gibt.<br/>\n' +
              'Ich sehe dann den Heiland, der mich liebt.</p>\n' +
              '\n' +
              '<p>2.\tIch sehe einst das Perlentor, es strahlt so hell und klar.<br/>\n' +
              'Ich sehe einst das wunderschöne Heim.<br/>\n' +
              'Ich sehe einst den weißen Thron und auch die Engelschar:<br/>\n' +
              'Der Erste, den ich seh, soll Jesus sein.</p>\n' +
              '\n' +
              '<p>Der Erste, den ich seh, soll Jesus sein,<br/>\n' +
              'und dann wird alles andre mich erfreun.<br/>\n' +
              'Anbetend werd ich stehn vor dem, der alles gibt.<br/>\n' +
              'Ich sehe dann den Heiland, der mich liebt.</p>\n' +
              '\n' +
              '<p>3.\tIch sehe einst die Lieben dort in jenem Himmelsland.<br/>\n' +
              'Und viele, die mit mir dann ziehen heim.<br/>\n' +
              'So mancher wartet dort auf mich an jenem goldnen Strand:<br/>\n' +
              'Der Erste, den ich seh, soll Jesus sein.</p>\n',
        },
        {
          headline: 'Beerdigung von Angelika Thiessen geb. Römmich',
          text: '<p>10:00 Uhr - Evangelische Kirche Oesterholz (Zur Kammersenne 17, 33189 Schlangen)</p>\n' +
              '\n' +
              '<p><strong>Begrüßung</strong> der Trauergäste von Martin Bergen ca. 2 min</p>\n' +
              '\n' +
              '\n' +
              '<p class="offset-1">Wir haben uns heute versammelt, um Abschied zu nehmen von Angelika Thiessen\n' +
              '    geb. Römmich. Ich möchte Sie alle Willkommen hießen im Namen der Familie\n' +
              '    Thiessen und Römmich.</p>\n' +
              '<p class="offset-1">Zum Ablauf: Wir werden gleich mit der Trauerfeier beginnen. Nach der Trauerfeier\n' +
              '    gehen wir zum Friedhof gegenüber der Kirche. Nach der Verabschiedung dort auf\n' +
              '    dem Friedhof gibt es eine Nachfeier in den Räumlichkeiten der Freien\n' +
              '    Christengemeinde Oesterholz. Wenn Sie zur Nachfeier bleiben, müssen Sie nicht\n' +
              '    umparken. Es ist gut zu Fuß erreichbar und es werden viele zu Fuß dahingehen. Da\n' +
              '    gibt es kein offizielles Programm, sondern es wird Kuchen geben und eine\n' +
              '    Bilderpräsentation über Angelika.</p>\n' +
              '<p class="offset-1">Angelika hat sich auf den heutigen Tag besser vorbereitet als wir. Heute wird\n' +
              '    einiges weitergegeben, was Sie sich gewünscht hat. Sogar für den heutigen Tag\n' +
              '    will Sie uns ermutigen. Sie hatte den Wunsch im Brautkleid und mit einer\n' +
              '    Kuchengabel beerdigt zu werden. Denn Sie wusste das Beste kommt noch. Auch\n' +
              '    hat Sie gerne gesungen, weshalb auch wir gleich einige Lieder singen werden.</p>\n' +
              '<p class="offset-1">Wir beginnen mit den beiden Liedern „Von guten Mächten wunderbar geborgen“\n' +
              '    und „In Christus ist mein ganzer Halt“. Danach möchte Peter den Lebenslauf von\n' +
              '    Angelika vorlesen.</p>\n' +
              '\n' +
              '<p><strong>Lied:</strong> Von guten Mächten wunderbar geborgen ca. 5 min</p>\n' +
              '<p><strong>Lied:</strong> In Christus ist mein ganzer halt         ca. 5 min</p>\n' +
              '<p><strong>Lebenslauf</strong> wird vorgelesen von Peter Thiessen (Matthias Traut) ca. 8 min</p>\n' +
              '\n' +
              '<p class="offset-1">Angelika hat sich vor längerer Zeit für Peter ein Lied gewünscht, das im Falle Ihres\n' +
              '    Todes auf der Beerdigung vorgespielt werden sollte. Wir hören jetzt das Wunschlied\n' +
              '    von Thea Eichholz-Müller, danach singen wir das „Lied komm zu Jesus“, die\n' +
              '    Geschichte von der Frau mit der Kuchengabel und dann die Predigt von Ralle.</p>\n' +
              '<p><strong>Wunschlied</strong> von Angelika für Peter: Wenn du mich sähst ca. 5 min</p>\n' +
              '<p><strong>Lied:</strong> Komm zu Jesus                 ca. 5 min</p>\n' +
              '<p><strong>Geschichte</strong> von der Frau mit der Kuchengabel (Peter Thiessen) ca. 5 min</p>\n' +
              '<p><strong>Predigt</strong> von Ralf Lobback (ca. 17 min)</p>\n' +
              '<p><strong>Lied:</strong> Im Himmel gibt es manches             ca. 5 min</p>\n' +
              '<p><strong>Organisatorische Ankündigungen</strong> von Martin Bergen ca. 3 min</p>\n' +
              '<p class="offset-1">Wie geht’s jetzt weiter:</p>\n' +
              '<p class="offset-1">An dieser Stelle möchte ich schon den Dank von Peter und Angelikas Eltern,\n' +
              'Heinrich und Katharina, für jegliche Unterstützung, für das Mittrauern, die\n' +
              'Wünsche, das Gebet und die praktischen Hilfen weitergeben.</p>\n' +
              '<p class="offset-1">Wir werden gleich den Trauermarsch zum Friedhof antreten. Dabei werden zuerst\n' +
              'die Träger der Blumengestecke vorgehen, dann die Sargträger mit dem Sarg. Hinter\n' +
              'dem Sarg geht die Familie und anschließend die Trauergemeinschaft.</p>\n' +
              '<p class="offset-1">Am Grab werde ich noch ein paar Worte sagen, bevor wir uns alle persönlich von\n' +
              'Angelika verabschieden.</p>\n' +
              '<p class="offset-1">Nach der Verabschiedung sind alle zur Nachfeier in die Räumlichkeiten der Freien\n' +
              'Christengemeinde Oesterholz eingeladen. Dort gibt es Kuchen und eine\n' +
              'Bilderpräsentation. Da im Keller nicht für alle Platz sein wird, bitte ich um\n' +
              'Rücksichtnahme. Wer mit dem Essen fertig sein wird, kann dann im Gemeindesaal\n' +
              'die Bilderpräsentation sehen.</p>\n' +
              '<p class="offset-1">Wir beginnen jetzt mit den Trauermarsch, ich bitte die Sargträger und die Träger der\n' +
              'Blumengestecke nach vorn zu kommen.</p>\n' +
              '<p class="text-center"><i>(Trauermarsch zum Friedhof währenddessen eröffnet durch die Glocken)</i></p>\n' +
              '<p class="text-center"><i>Blumengestecke-Träger <br/>\n' +
              'Sargträger <br/>\n' +
              'Familie <br/>\n' +
              'Trauergemeinschaft</i></p>\n' +
              '<p>11:00 Uhr - Friedhof Oesterholz (Zur Kammersenne 22, 33189 Schlangen)</p>\n' +
              '<p class="text-center">(Sobald die Glocken aufhören zu läuten, startet der Posaunenchor auf dem Friedhof)</p>\n' +
              '<p><strong>Verabschiedungsworte</strong> von Martin Bergen         ca. 5 min</p>\n' +
              '<p class="text-center offset-1"><i>\n' +
              '1. Korinther 15, 45-57:<br/>\n' +
              '„45 So steht auch geschrieben: Der erste Mensch, Adam, »wurde zu einer\n' +
              'lebendigen Seele«; der letzte Adam zu einem lebendigmachenden Geist. 46 Aber\n' +
              'nicht das Geistliche ist das Erste, sondern das Natürliche, danach [kommt] das\n' +
              'Geistliche. 47 Der erste Mensch ist von der Erde, irdisch; der zweite Mensch ist der\n' +
              'Herr aus dem Himmel. 48 Wie der Irdische beschaffen ist, so sind auch die\n' +
              'Irdischen; und wie der Himmlische beschaffen ist, so sind auch die Himmlischen.\n' +
              '49 Und wie wir das Bild des Irdischen getragen haben, so werden wir auch das Bild\n' +
              'des Himmlischen tragen. 50 Das aber sage ich, Brüder, dass Fleisch und Blut das\n' +
              'Reich Gottes nicht erben können; auch erbt das Verwesliche nicht die\n' +
              'Unverweslichkeit. 51 Siehe, ich sage euch ein Geheimnis: Wir werden zwar nicht\n' +
              'alle entschlafen, wir werden aber alle verwandelt werden, 52 plötzlich, in einem\n' +
              'Augenblick, zur Zeit der letzten Posaune; denn die Posaune wird erschallen, und\n' +
              'die Toten werden auferweckt werden unverweslich, und wir werden verwandelt\n' +
              'werden. 53 Denn dieses Verwesliche muss Unverweslichkeit anziehen, und dieses\n' +
              'Sterbliche muss Unsterblichkeit anziehen. 54 Wenn aber dieses Verwesliche\n' +
              'Unverweslichkeit anziehen und dieses Sterbliche Unsterblichkeit anziehen wird,\n' +
              'dann wird das Wort erfüllt werden, das geschrieben steht: »Der Tod ist\n' +
              'verschlungen in Sieg! 55 Tod, wo ist dein Stachel? Totenreich, wo ist dein Sieg?«\n' +
              '56 Der Stachel des Todes aber ist die Sünde, die Kraft der Sünde aber ist das\n' +
              'Gesetz. 57 Gott aber sei Dank, der uns den Sieg gibt durch unseren Herrn Jesus\n' +
              'Christus!“</i></p>\n' +
              '<p class="offset-1">Wir haben Angelika nicht zum letzten Mal gesehen oder gehört. Das war Angelika\n' +
              'sehr bewusst. Dieser Abschied ist nicht für immer, auch wenn er vorerst für eine\n' +
              'längere Zeit ist. Aus diesem Grund sagen wir „Auf Wiedersehen“, denn es wir ein\n' +
              'Wiedersehen geben, wenn wir Sie verwandelt neben unserem Herrn und Heilland\n' +
              'Jesus Christus stehen sehen.</p>\n' +
              '<p class="offset-1">Sie hat das Bild des Irdischen getragen. Von nun an wird sie das Bild des\n' +
              'Himmlichen tragen. Auf Wiedersehen, Angelika.</p>\n' +
              '<p class="text-center"><i>(Sarg wird ins Grab herabgelassen)</i></p>\n' +
              '<p class="text-center"><i>(während der Verabschiedung spielt der Posaunenchor 2 Lieder)</i></p>\n' +
              '<p class="text-center"><i>Martin Bergen</i></p>\n' +
              '<p class="text-center"><i>Familie</i></p>\n' +
              '<p class="text-center"><i>Verwandtschaft</i></p>\n' +
              '<p class="text-center"><i>Trauergemeinschaft</i></p>\n' +
              '<p>11:30 Uhr - Nachfeier in der Freien Christengemeinde Oesterholz (Dorfplatz 3, 33189 Schlangen)</p>\n' +
              '<p class="offset-1">Im Gemeindesaal wird das Lied „Wenn du mich sähst“ mit der Bilderpräsentation in einer\n' +
              'Schleife laufen.</p>\n' +
              '<p class="offset-1">Eventuell kann dies auch einmal unten gezeigt werden.</p>\n',
        },
        {
          headline: 'Predigt zur Trauerfeier von Angelika Thiessen',
          text: '<p>Wir sind alle heute Morgen sehr bewegt, ganz besonders natürlich die nahen Angehörigen,\n' +
              'wie der Ehemann und die Eltern von Angelika. Es ist ein schwieriger Tag und es liegen auch\n' +
              'schwierige Zeiten hinter der Familie.<br/>\n' +
              'Der Tod eines geliebten Menschen macht uns traurig, das ist ganz einfach so.</p>\n' +
              '<p>Und jetzt wollen wir auch gern Trost finden. Nicht dass ein Trost die Trauer so einfach\n' +
              'wegwischen kann. Nein, wir suchen nach Trost, damit der Schmerz nicht so groß ist.</p>\n' +
              '<p>Unser Gott – er ist der Tröster schlechthin. Er wird in der Bibel als der <strong>Gott allen Trostes</strong>\n' +
              'bezeichnet. <i>Ist das nicht ein wunderbarer Name?</i><br/>\n' +
              'Wohl dem, der diesen Gott kennt!</p>\n' +
              '<p>Ich möchte nun einige tröstende Worte aus dem Wort Gott lesen.\n' +
              'Ich lese aus dem <strong>1.Thess.</strong> einige Verse – <strong>4,13-18.</strong></p>\n' +
              '<p><strong>„So tröstet nun einander mit diesen Worten!“</strong> – so schließt Paulus diesen Sinnabschnitt.</p>\n' +
              '<p><i>Inwieweit sind diese eben gelesenen Worte ein Trost für uns alle, insbesondere für die\n' +
              'Nahestehenden unserer lieben Schwester?</i><br/>\n' +
              'Das möchte ich kurz erklären. <br/>\n' +
              'Es gab in Thess. eine Gemeinde. Eine Gemeinde wie es heute viele gibt. Man geht davon\n' +
              'aus, dass der Brief knapp 20 Jahre nach dem Tod des Herrn Jesus geschrieben wurde. Als\n' +
              'Jesus nach seiner Auferstehung gen Himmel fuhr, da hatte er seinen Jüngern das\n' +
              'Versprechen gegeben, wiederzukommen. Die Gemeinde lebte in der Erwartung: Der Herr\n' +
              'kommt bald.</p>\n' +
              '<p>Aber in ihrer Mitte starben Menschen. Und jetzt fragten sich die damaligen Christen: <i>Was\n' +
              'wird mit ihnen sein? Jesus ist noch nicht wiedergekommen und sie sterben!</i></p>\n' +
              '<p>Dieses Problem hatten die Thess. und diese Frage beschäftigt auch heute die Menschen. Da\n' +
              'stirbt ein Mensch und die Frage, die sich dann fast schon aufdrängt, lautet: <i>Was wird mit ihr,\n' +
              'was wird mit ihm sein?</i></p>\n' +
              '<p>Nun, Gott sei Dank. Er hat dem Paulus befohlen den Christen darauf eine Antwort zu geben.\n' +
              'Wir tappen nicht im Dunkeln – ich kann heute Morgen eine exakte Antwort darauf geben,\n' +
              'was mit Angelika geschehen ist.</p>\n' +
              '<p>Zunächst einmal geht es ja in diesem Text um die „Entschlafenen“. Dieses Wort wird in der\n' +
              'Bibel nur für Christen gebraucht, die sterben. <strong>Nichtchristen sterben, Gläubige hingegen\n' +
              'entschlafen.</strong><br/>\n' +
              'Heute wird das über einen Kamm geschoren – fast durchweg wird über Menschen in\n' +
              'Todesanzeigen gesagt, sie seien entschlafen. Die Bibel trifft allerdings diese\n' +
              'Unterscheidung. <br/>\n' +
              'Für Christen hat der Tod seinen Schrecken verloren. Jesus Christ hat den Tod besiegt.\n' +
              'Deshalb nennt die Bibel einen Christen, der stirbt, einen Entschlafenen. Angelika ist\n' +
              'entschlafen.</p>\n' +
              '<p>Des Weiteren macht Paulus eine sehr interessante Aussage, die wir kurz betrachten wollen.\n' +
              'Paulus möchte die Thess. aufklären, damit sie nicht mehr traurig sind wie die anderen, die\n' +
              'keine Hoffnung haben. <br/>\n' +
              'Er sagt nicht: damit ihr nicht mehr traurig seid, sondern er sagt <strong>damit ihr nicht mehr traurig\n' +
              'seid wie die anderen, die keine Hoffnung haben.</strong></p>\n' +
              '<p><i>Was haben wir darunter zu verstehen?</i><br/>\n' +
              'In die Trauer der Angehörigen mischt sich – da die meisten von ihnen gläubige Menschen\n' +
              'sind – eine tiefe Gewissheit ein. Sie sind nicht traurig wie die anderen, die keine Hoffnung\n' +
              'haben. Sie wissen, ihre liebe Ehefrau, Mutter und Tochter hat es jetzt viel besser. Sie hat es\n' +
              'viel besser als jemals zuvor. Und das für immer.</p>\n' +
              '<p>Auch wenn unser Text das nicht sagt, so sagt Paulus doch an anderer Stelle <strong>Ich habe Lust\n' +
              'aus der Welt zu scheiden und bei Christus zu sein, was auch viel besser wäre.</strong><br/>\n' +
              'Er versteht das Ganze so: Stirbt ein Christ und verlässt diese Welt, so ist er beim Herrn. Und\n' +
              'das ist besser als hier zu bleiben.</p>\n' +
              '<p>Ihr habt eine geliebte Person verloren. Aber sie hat nicht verloren und sie ist auch nicht\n' +
              'verloren. Ihr geht es gut. <br/>\n' +
              'Und ich meine in einem solchen Wissen liegt doch ein unsagbar großer Trost – und das will\n' +
              'Paulus ja hier auch tun, er will trösten!</p>\n' +
              '<p>Aber ich möchte es auch noch einmal betonen: Nur ein Christ – und ein solcher war unsere\n' +
              'liebe Schwester – kann mit Zuversicht in die Zukunft schauen. Ein solcher Mensch weiß,\n' +
              'was nach dem Tode kommt, und er weiß auch, dass das, was kommt, viel besser ist als das\n' +
              'Leben hier auf Erden.</p>\n' +
              '<p>Ein Nichtchrist hingegen weiß nicht, was auf ihn zukommt. Er hat keine Zuversicht. Für ihn\n' +
              'ist das Sterben eine äußerst mysteriöse Angelegenheit. Er stirbt ohne Hoffnung.</p>\n' +
              '<p>Auch herrscht hier heute Morgen Traurigkeit, aber sie sieht nicht so aus wie die Traurigkeit\n' +
              'der Nichtchristen. Sie haben keine Hoffnung. <br/>\n' +
              'Aber unsere Schwester, die hatte Hoffnung. <br/>\n' +
              'Wenn wir einen Blick in den Sarg werfen könnten, so würden wir sehen, dass die\n' +
              'Verstorbene eine Kuchengabel in der Hand hält, davon haben wir schon gehört.\n' +
              'Aber wir würden noch etwas sehen. Sie trägt ihr Brautkleid, das sie bei ihrer Hochzeit trug.\n' +
              'Warum das? <br/>\n' +
              'Hier kommt Angelikas hoffnungsvolles Vertrauen ins Spiel. Sie sah sich als Teil der Braut\n' +
              'Christi. So wird ja auch die Gemeinde bezeichnet, als Braut Christi. Und so war es ihr\n' +
              'Wunsch, so gekleidet zu sein. Weil sie wusste, sie ist Teil der Braut Christi, sie gehört dazu.\n' +
              'Und deshalb war sie sich auch darüber hinaus gewiss, dass sie am Hochzeitsmahl des\n' +
              'Lammes teilnehmen würde. Ein Ereignis, das sich nach unserem Eintritt in die himmlische\n' +
              'Welt ereignen wird. <br/>\n' +
              'Das Beste kommt noch! Das ist ja das von Angelika gewünschte Motto für diese Trauerfeier!</p>\n' +
              '<p>Liebe Trauergäste: Das ist wirklich ein Entschlafen und kein jämmerliches Sterben, wie es\n' +
              'doch so oft in unserer Welt stattfindet. Auch wenn es ein langer Leidenskampf war. Angelika\n' +
              'hat die Zuversicht, die Hoffnung, die weit über dieses irdische Leben hinausreicht, nicht\n' +
              'verloren. Nein, sie hat bis zuletzt Hoffnung gelebt. Sie war sich gewiss, dass sie zum Herrn\n' +
              'gehen würde!! <br/>\n' +
              'Und der Herr nahm sie zu sich.</p>\n' +
              '<p>Jesus Christus ist am Kreuz von Golgatha gestorben, aber er ist aus den Toten\n' +
              'auferstanden. Er blieb nicht im Grab. <br/>\n' +
              'Wenn der Herr wiederkommen wird, dann werden die zu diesem Zeitpunkt lebenden\n' +
              'Christen nicht den Entschlafenen zuvorkommen. <br/>\n' +
              'Käme heute der Herr, um seine Gemeinde abzuholen, so würden wir Angelika nicht\n' +
              'zuvorkommen. Denn die Toten werden zuerst auferstehen und dann werden wir zusammen\n' +
              'mit ihnen zum Herrn gehen. <br/>\n' +
              'Und hier wird es ein Wiedersehen geben. <br/>\n' +
              'Was für ein triumphaler Tag wartet doch auf uns! Und ganz besonders auf dich Peter und\n' +
              'deine Familie!</p>\n' +
              '<p><i>Ist das nicht ein Trost?</i></p>\n' +
              '<p>Paulus schrieb an Menschen, die sich unsicher waren in Bezug auf die Auferstehung. Paulus\n' +
              'wollte sie nicht in Unwissenheit lassen. Deshalb klärt er sie auf. Und das Ziel bei dem\n' +
              'Ganzen ist sie zu trösten, damit sie nicht mehr traurig sind wie die anderen.</p>\n' +
              '<p>Ich möchte noch kurz auf die anderen zu sprechen kommen. Menschen sterben, jeden Tag\n' +
              'sterben unzählig viele Menschen in dieser Welt. Wir wissen ganz genau, dass auch wir\n' +
              'einmal sterben müssen. Und doch schieben wir diesen Gedanken an unser eigenes Sterben\n' +
              'beiseite. Wir wollen uns keine Gedanken darum machen.</p>\n' +
              '<p>Mose bat Gott darum, die Menschen zu lehren, dass sie sterben müssen. <strong>Lehre uns\n' +
              'bedenken, dass wir sterben müssen, damit wir klug werden…</strong><br/>\n' +
              'Wir brauchen ein Stück Unterweisung auf diesem Gebiet.</p>\n' +
              '<div class="p-3 mb-3 d-inline-block border"><p class="mb-0">Das, was wir heute Morgen erleben, <br/>\n' +
              'das ist ein solche Unterweisung.</p></div>\n' +
              '<p>Wir sind fast gezwungen, uns mit dem Gedanken auseinander zu setzen, dass es ja auch\n' +
              'unsere Beerdigung sein könnte.</p>\n' +
              '<p><i>Wie können uns aber Gedanken um das Sterben klug machen?</i><br/>\n' +
              'Wir sollten uns noch hier auf Erden darauf vorbereiten, unserem Gott zu begegnen – ich\n' +
              'denke das meinte Mose. Auf diese Art und Weise können wir klug werden. <br/>\n' +
              'Die meisten Menschen, die auf diese große Reise gehen, sind darauf völlig unvorbereitet.\n' +
              'Auf die kleinen Reisen im Leben da bereitet man sich akribisch vor. Da darf man nicht einmal\n' +
              'eine Kleinigkeit vergessen. <br/>\n' +
              'Aber diese letzte Reise wird völlig unvorbereitet angetreten. Das muss aber nicht so sein.\n' +
              'Unsere liebe Schwester war bestens vorbereitet. Und das war für mich ein großes Zeugnis.\n' +
              'Sie hatte Glauben, Glauben an unseren Herrn Jesus Christus.</p>\n' +
              '<p>Ich möchte ihnen einen Rat geben, eine guten Rat. Wenn sie die Angst befällt, wenn sie sich\n' +
              'Sorgen um ihre eigene Seele machen, dann fliehen sie zu dem, der den Tod besiegt hat.\n' +
              'Dann kann ihnen womöglich dieses Begräbnis das Leben bringen. Ich bin zutiefst davon\n' +
              'überzeugt, dass genau das im Sinne der Verstorbenen wäre.\n' +
              'Ich möchte schließen mit einigen Versen aus <strong>1.Kor.15</strong><br/>\n' +
              '<strong>AMEN</strong></p>\n',
        },
      ],
      index: 0,
    }
  },
  methods: {
    show: function (index) {
      var _that = this
      _that.index = index

      Vue.nextTick(function () {
        _that.$refs.lightbox.show()
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "~vue-pure-lightbox/dist/VuePureLightbox.css";

.lightbox-holder {
  max-height: 80vh;

  .text-holder {
    overflow: scroll;
    max-height: 80vh;
  }
}

.square {
  img {
    top: 0;
  }
  h3 {
    margin-top: -1rem;
  }
}

</style>
